// Settings shell (Phase 4b plan §1 A; billing spec §4.1): a title, one tab per section, the section
// below. Billing and Agreements join TABS when they are built.
import React from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import PartnerRulesTab from './partnerRules/PartnerRulesTab';
import RuleBuilder from './partnerRules/RuleBuilder';
import VisibilityTab from './visibility/VisibilityTab';
import AiAssistantsTab from './aiAssistants/AiAssistantsTab';

const TABS = [
  { path: 'partner-rules', label: 'Partner rules' },
  { path: 'visibility', label: 'Visibility' },
  { path: 'ai-assistants', label: 'AI assistants' },
];

export default function SettingsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const current = TABS.find((t) => location.pathname.startsWith(`/settings/${t.path}`))?.path || TABS[0].path;

  return (
    <Box sx={{ maxWidth: 1000 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
        Settings
      </Typography>
      <Tabs
        value={current}
        onChange={(_e, value) => navigate(`/settings/${value}${location.search}`)}
        variant="scrollable"
        allowScrollButtonsMobile
        aria-label="Settings"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
      >
        {TABS.map((t) => (
          <Tab key={t.path} value={t.path} label={t.label} />
        ))}
      </Tabs>
      <Routes>
        <Route path="partner-rules" element={<PartnerRulesTab />} />
        <Route path="partner-rules/new" element={<RuleBuilder />} />
        <Route path="partner-rules/:ruleId/change" element={<RuleBuilder />} />
        <Route path="visibility" element={<VisibilityTab />} />
        <Route path="ai-assistants" element={<AiAssistantsTab />} />
        <Route path="*" element={<Navigate to="partner-rules" replace />} />
      </Routes>
    </Box>
  );
}
